/**
 * Skeleton Component — shimmer placeholder for loading states
 * For Media Devoted | Created By Ciro Autiero
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Number of stacked placeholder rows to render. Defaults to 1. */
  count?: number;
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, count = 1, ...props }, ref) => {
    if (count <= 1) {
      return (
        <div
          ref={ref}
          aria-hidden
          className={cn('animate-pulse rounded-md bg-muted', className)}
          {...props}
        />
      );
    }

    return (
      <div ref={ref} aria-hidden className="flex flex-col gap-2" {...props}>
        {Array.from({ length: count }, (_, index) => (
          <div
            key={index}
            className={cn('animate-pulse rounded-md bg-muted', className)}
          />
        ))}
      </div>
    );
  },
);
Skeleton.displayName = 'Skeleton';

export { Skeleton };
